// Ländernamen: die Datenbank speichert deutsche Namen („Frankreich“); angezeigt wird der Name in der Sprache der
// Seite (Intl.DisplayNames). Zwilling: lib/country.js (Gleichheit per Test), Tabelle lib/country-iso.json.
import ISO from '../../lib/country-iso.json' with { type: 'json' };

const cache = new Map();
export function countryIso(name) { return (name && ISO[name]) || null; }
export function countryName(name, lang) {
  if (!name) return '';
  const iso = countryIso(name);
  if (!iso || !lang || lang === 'de') return name;
  try {
    if (!cache.has(lang)) cache.set(lang, new Intl.DisplayNames([lang], { type: 'region' }));
    const out = cache.get(lang).of(iso);
    return out && out !== iso ? out : name;
  } catch { return name; }
}
